import React from 'react'
import Svg from '../Svg'

const Icon = (props) => {
  return (
    <Svg {...props}>
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_75_11469)">
          <g filter="url(#filter0_bdi_75_11469)">
            <path
              d="M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z"
              fill="#2B1B4E"
              fillOpacity="0.4"
              shapeRendering="crispEdges"
            />
            <path
              d="M39.5 20C39.5 30.7696 30.7696 39.5 20 39.5C9.23045 39.5 0.5 30.7696 0.5 20C0.5 9.23045 9.23045 0.5 20 0.5C30.7696 0.5 39.5 9.23045 39.5 20Z"
              stroke="#814BF6"
              strokeOpacity="0.2"
              shapeRendering="crispEdges"
            />
          </g>
          <path
            d="M26.9209 13.2613C25.6252 12.6669 24.2578 12.2434 22.8529 12.0014C22.8401 11.9986 22.8268 12.0001 22.8149 12.0056C22.803 12.0112 22.7933 12.0205 22.7873 12.0322C22.6011 12.3703 22.432 12.7175 22.2806 13.0725C20.7657 12.8427 19.2249 12.8427 17.71 13.0725C17.559 12.7163 17.3877 12.3689 17.1972 12.0322C17.1907 12.021 17.1809 12.012 17.1691 12.0065C17.1574 12.001 17.1443 11.9992 17.1315 12.0014C15.7256 12.2424 14.3572 12.6667 13.0615 13.2634C13.0505 13.2679 13.0411 13.2758 13.0348 13.2859C10.4439 17.156 9.73407 20.9337 10.0828 24.6642C10.0854 24.6827 10.0949 24.6996 10.1095 24.7114C11.6184 25.8292 13.3061 26.6826 15.1006 27.2353C15.1133 27.239 15.1269 27.2386 15.1394 27.2342C15.1519 27.2298 15.1627 27.2215 15.1703 27.2107C15.557 26.6863 15.9 26.1311 16.1961 25.5506C16.2001 25.5426 16.2024 25.5339 16.2028 25.5249C16.2032 25.516 16.2017 25.507 16.1984 25.4987C16.1951 25.4904 16.1901 25.4828 16.1837 25.4766C16.1772 25.4703 16.1696 25.4655 16.1612 25.4624C15.6215 25.2576 15.0988 25.0106 14.598 24.7237C14.5891 24.7179 14.5818 24.71 14.5767 24.7007C14.5717 24.6914 14.569 24.6809 14.569 24.6703C14.569 24.6597 14.5717 24.6493 14.5767 24.64C14.5818 24.6307 14.5891 24.6227 14.598 24.617C14.7026 24.539 14.8031 24.4569 14.9078 24.3748C14.9173 24.3688 14.9283 24.3656 14.9396 24.3656C14.9508 24.3656 14.9618 24.3688 14.9714 24.3748C16.5439 25.1136 18.26 25.4967 19.9974 25.4967C21.7347 25.4967 23.4508 25.1136 25.0234 24.3748C25.0333 24.3689 25.0446 24.3657 25.0562 24.3657C25.0677 24.3657 25.0791 24.3689 25.089 24.3748C25.1895 24.4569 25.2941 24.541 25.3988 24.619C25.4077 24.6248 25.415 24.6327 25.42 24.642C25.4251 24.6513 25.4277 24.6618 25.4277 24.6724C25.4277 24.683 25.4251 24.6934 25.42 24.7027C25.415 24.712 25.4077 24.72 25.3988 24.7257C24.9007 25.0163 24.3792 25.2648 23.8397 25.4685C23.8238 25.4729 23.8102 25.4832 23.8018 25.4974C23.7934 25.5116 23.7908 25.5284 23.7945 25.5445C24.0961 26.1218 24.4389 26.6766 24.8203 27.2045C24.8276 27.2156 24.8384 27.224 24.851 27.2285C24.8636 27.2329 24.8773 27.2332 24.89 27.2291C26.6875 26.6775 28.3781 25.824 29.8893 24.7052C29.9039 24.6934 29.9134 24.6766 29.916 24.658C30.3263 20.3489 29.2165 16.5999 26.9599 13.2777C26.955 13.2723 26.949 13.268 26.9423 13.2651C26.9355 13.2623 26.9282 13.261 26.9209 13.2613ZM16.6802 22.3926C15.6955 22.3926 14.8831 21.4877 14.8831 20.3776C14.8831 19.2675 15.6791 18.3625 16.6802 18.3625C17.6813 18.3625 18.4916 19.2736 18.4752 20.3776C18.4588 21.4815 17.6813 22.3926 16.6802 22.3926ZM23.3207 22.3926C22.336 22.3926 21.5257 21.4877 21.5257 20.3776C21.5257 19.2675 22.3216 18.3625 23.3207 18.3625C24.3197 18.3625 25.1341 19.2736 25.1177 20.3776C25.1013 21.4815 24.33 22.3926 23.3207 22.3926Z"
            fill="white"
          />
        </g>
        <defs>
          <filter
            id="filter0_bdi_75_11469"
            x="-10"
            y="-10"
            width="60"
            height="60"
            filterUnits="userSpaceOnUse"
            colorInterpolationFilters="sRGB"
          >
            <feFlood floodOpacity="0" result="BackgroundImageFix" />
            <feGaussianBlur in="BackgroundImage" stdDeviation="5" />
            <feComposite in2="SourceAlpha" operator="in" result="effect1_backgroundBlur_75_11469" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feComposite in2="hardAlpha" operator="out" />
            <feColorMatrix type="matrix" values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0" />
            <feBlend mode="normal" in2="effect1_backgroundBlur_75_11469" result="effect2_dropShadow_75_11469" />
            <feBlend mode="normal" in="SourceGraphic" in2="effect2_dropShadow_75_11469" result="shape" />
            <feColorMatrix
              in="SourceAlpha"
              type="matrix"
              values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
              result="hardAlpha"
            />
            <feOffset dy="1" />
            <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
            <feColorMatrix type="matrix" values="0 0 0 0 0.505882 0 0 0 0 0.294118 0 0 0 0 0.964706 0 0 0 0.2 0" />
            <feBlend mode="normal" in2="shape" result="effect3_innerShadow_75_11469" />
          </filter>
          <clipPath id="clip0_75_11469">
            <rect width="40" height="40" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </Svg>
  )
}

export default Icon
